// Dummy data hook for salary doughnut chart
export default function useSalaryDoughnutData() {
  return [
    { component: 'Basic', value: 40000 },
    { component: 'HRA', value: 10000 },
    { component: 'Bonus', value: 5000 },
    { component: 'Deductions', value: 3000 },
  ];
}
